import React from "react";


const Timeline = () => {
  const timelineData = [
    { month: "Month 1", title: "Python, Statistics(Math)", icon: "assets/images/icons/5.webp" },
    { month: "Month 2", title: "Statistics(Math) & ML", icon: "assets/images/icons/Math.png" },
    { month: "Month 3", title: "ML in Depth", icon: "assets/images/icons/mllearning.png" },
    { month: "Month 4", title: "Deep Learning", icon: "assets/images/icons/deeplearning.png" },
    { month: "Month 5", title: "NLP, GenAI", icon: "assets/images/icons/nlp.png" },
    { month: "Month 6", title: "GenAI", icon: "assets/images/icons/aiGenAI.png" },
    { month: "Month 7", title: "Projects", icon: "assets/images/icons/projectDetail.png" },
    { month: "Month 8", title: "Projects", icon: "assets/images/icons/project1.png" },
  ];

  const timelineData1 = [
    { month: "Mock Interviews", title: "Mock Interviews", icon: "assets/images/overviewImage/liveicon-6.png" },
    { month: "Resume Preparation", title: "Resume Preparation", icon: "assets/images/icons/cv.png" },
    { month: "Job Selection", title: "Job Referrals", icon: "assets/images/icons/joboffer.png" },
  ];

  return (
    <div className="timeline-container">
<h2 className="title">Data Science Course Roadmap</h2>
      <div className="timeline-wrapper">
        {timelineData.map((item, idx) => (
          <div key={idx} className="timeline-item">

            <div className="timeline-step">
              <div className="timeline-circle">
                  <img src={item.icon} className="timeline-icon-img" />
              </div>
                  {idx !== timelineData.length - 1 && <div className="timeline-arrow">›</div>}
                </div>
                <p className="timeline-month">{item.month}</p>
                {item.title && <p className="timeline-title">{item.title}</p>}
            </div>
        ))}
      </div>
     

      <div className="timeline-wrapper">
        {timelineData1.map((item, idx) => (
          <div key={idx} className="timeline-item">
             <div className="timeline-step">
            <div className="timeline-circle">
            <img src={item.icon} className="timeline-icon-img" />
            </div>
            {idx !== timelineData.length - 1 && <div className="timeline-arrow">›</div>}
            </div>
            <p className="timeline-month">{item.month}</p>
            {item.title && <p className="timeline-title">{item.title}</p>}
          </div>

        ))}
      </div>

      <div className="timeline-footer">✓ Job Referrals + Support</div>
    </div>
  );
};

export default Timeline;
